<template>
  <div
    class="mt-2"
  >
    <div
      class="d-flex justify-content-between align-items-center"
      style="width: 100%; margin-bottom: 20px"
    >
      <h5 class="mb-0">
        {{ $t('documentRequests.title.attachmentList') }}
      </h5>
    </div>
    <div
      v-if="attachments.length"
      style="height: 100%"
    >
      <b-card
        v-for="(attachment, index) in attachments"
        :key="index"
        no-body
        class="mb-1"
      >
        <b-card-header
          header-tag="header"
          class="p-1"
          role="tab"
        >
          <div class="d-flex justify-content-between align-items-center">
            <b-link
              :href="attachment.link"
              target="_blank"
            >
              <b>
                {{ attachment.name }}
              </b>
            </b-link>
          </div>
          <div
            class="d-flex align-items-center"
          >
            <b-button
              v-b-modal.remove-attachment-modal
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              size="sm"
              variant="outline-danger"
              class="mr-2"
              @click="indexAttachmentRemoveItem = index"
            >
              <feather-icon
                icon="XIcon"
                size="10"
              />
            </b-button>
          </div>
        </b-card-header>
      </b-card>
    </div>

    <b-modal
      id="remove-attachment-modal"
      :title="$t('application.deleteAttachmentModal.title')"
      ok-variant="danger"
      @ok="removeAttachment"
    >
      <p class="mt-1 d-flex justify-content-between">
        <span>
          {{ $t("application.deleteAttachmentModal.content") }}
        </span>
      </p>
    </b-modal>
  </div>
</template>

<script>
import {
  BButton,
  BCard,
  BCardHeader,
  BModal,
  BLink,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BButton,
    BCard,
    BCardHeader,
    BModal,
    BLink,
  },
  directives: {
    Ripple,
  },
  props: {
    attachments: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      indexAttachmentRemoveItem: -1,
    }
  },
  methods: {
    removeAttachment() {
      if (this.indexAttachmentRemoveItem > -1) {
        const newStateAttachments = this.attachments
          .filter((item, index) => this.indexAttachmentRemoveItem !== index)

        this.$emit('update-attachment-requested', newStateAttachments)
      }
    },
  },
}
</script>

<style lang="scss">
@import "@hw-ui/scss/vue/libs/vue-flatpicker.scss";
</style>

<style lang="scss" scoped>
div[role="tablist"] {
  flex-direction: column;
  .card {
    border-bottom: 0;
    ::v-deep .card-header {
      padding: 0.75rem 1.25rem 0.75rem 0.75rem;
      background-color: #fff;
      border: 1px solid rgba(34, 41, 47, 0.125);
      border-radius: 0.357rem;
      margin-bottom: 0.5rem;
    }
  }
}
</style>
